import Vue from 'vue'
import store from 'store'
import { mapState } from 'vuex'
import { formatPrice } from 'utils/general'

export default el => new Vue({
  el,
  store,
  data () {
    return {
      noteExpanded: false,
      message: ''
    }
  },
  mounted () {
    this.message = this.cart.note
  },
  computed: {
    ...mapState('global', [
      'cart'
    ]),
    ...mapState('cart', [
      'loading'
    ]),
    cartItems () {
      this.toggleEmptyClass()
      return (this.cart.items || [])
    },
    cartQuantity () {
      let qty = 0
      const items = this.cartItems.filter(item => __GLOBAL__.engravingItem.id !== item.id)
      for (let i = 0; i < items.length; i++) {
        qty = qty + items[i].quantity
      }
      return qty
    },
    isEmpty () {
      return this.cartItems.length === 0
    },
    cartTotal () {
      return formatPrice(this.cart.total_price)
    }
  },
  methods: {
    toggleEmptyClass () {
      const cartWrapper = document.querySelector('.template--cart')
      if (cartWrapper) {
        if (this.cart.items.length <= 0) {
          cartWrapper.classList.add('cart-is-empty')
        } else {
          cartWrapper.classList.remove('cart-is-empty')
        }
      }
    },
    priceFormat (price) {
      return formatPrice(price)
    },
    toggleNote () {
      this.noteExpanded = !this.noteExpanded
    },
    checkoutCart () {
      this.$refs.cartForm.submit()
    }
  }
})
